import { useForm } from '@inertiajs/react'
import { Card } from '../../components/core/Card.jsx'
import { Button } from '../../components/core/Button.jsx'
import { Field } from '../../components/forms/Field.jsx'
import { Input } from '../../components/forms/Input.jsx'
import { Select } from '../../components/forms/Select.jsx'
import { AdminLayout } from '../../admin/AdminLayout.jsx'

// Creating a complimentary account — somebody to test or evaluate the product
// without paying, decided 2026-10-12. They get an email with a seven-day link
// to set a password; nothing collects until they open it and add a business.
export default function AdminNewAccount({ plans = [], errors = {} }) {
  const form = useForm({ email: '', name: '', plan: 'starter', comped_until: '' })

  function submit(e) {
    e.preventDefault()
    form.post('/admin/accounts')
  }

  return (
    <AdminLayout title="Add an account">
      <Card pad="lg" title="Complimentary account" description="Free for as long as you choose. They can buy a plan at any time.">
        <form onSubmit={submit} className="flex max-w-xl flex-col gap-5">
          <Field label="Their email address" htmlFor="email" required error={errors.email}>
            <Input id="email" name="email" type="email" value={form.data.email} invalid={Boolean(errors.email)}
              onChange={(e) => form.setData('email', e.target.value)} />
          </Field>
          <Field label="Account name" htmlFor="name" hint="Optional. Their agency or business; it becomes the first business's name once they add one.">
            <Input id="name" name="name" value={form.data.name} onChange={(e) => form.setData('name', e.target.value)} />
          </Field>
          <Field label="Plan" htmlFor="plan" required hint="Sets how many businesses they can track and the monthly allowance." error={errors.plan}>
            <Select id="plan" name="plan" value={form.data.plan} invalid={Boolean(errors.plan)}
              onChange={(e) => form.setData('plan', e.target.value)}>
              {plans.map((p) => (
                <option key={p.key} value={p.key}>
                  {p.label} — {p.businesses} {p.businesses === 1 ? 'business' : 'businesses'}
                </option>
              ))}
            </Select>
          </Field>
          <Field label="Free until" htmlFor="comped_until" hint="Optional. Leave blank for no end. When it ends, collection stops and nothing is removed." error={errors.comped_until}>
            <Input id="comped_until" name="comped_until" type="date" value={form.data.comped_until} invalid={Boolean(errors.comped_until)}
              onChange={(e) => form.setData('comped_until', e.target.value)} />
          </Field>
          <div>
            <Button variant="primary" size="lg" as="button" loading={form.processing}>Create and send the invitation</Button>
          </div>
        </form>
      </Card>
    </AdminLayout>
  )
}
